import React, {useEffect, useState} from "react";
import {Menu} from "antd";
import Sider from "antd/es/layout/Sider";
import {Store} from "utils/mobx";
import {toJS} from "mobx";
import {processMenuItems} from "utils/functions";
import './index.scss'

interface  PaiPointAdminSiderProps {
    collapsed: boolean
}
const PaiPointAdminSider: React.FC<PaiPointAdminSiderProps> = (props) => {
    const {
        collapsed
    } = props
    const {
        adminSiderMenuList,
    } = Store.AdminSiderStore
    const [adminMenuData, setAdminMenuData] = useState<any[]>([])

    useEffect(() => {
        const menuItems = processMenuItems(toJS(adminSiderMenuList), "0")
        setAdminMenuData(menuItems)
    }, [adminSiderMenuList])

    return (
        <Sider
            trigger={null}
            collapsible
            collapsed={collapsed}
            className={'pai-point-admin-menu-sider-container'}
        >
            <div className="logo-container">
            </div>
            <Menu
                theme="dark"
                mode="inline"
                className={'menu-container'}
                defaultSelectedKeys={['1']}
                items={adminMenuData}
            />
        </Sider>
    )
}

export default PaiPointAdminSider;